import React from 'react';
import { Formik } from 'formik';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { InputField, SwitchField } from '../../../../components/forms/fields';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { sanitizeFormValues } from '../../../../utils';
import { CustomPaymentMethodFormProps, CustomPaymentMethodFormValues } from './types';
import { customPaymentMethodValidationSchema } from './validation';

const CustomPaymentMethodForm = ({
    submitText,
    onSubmit,
    initialValues,
}: CustomPaymentMethodFormProps) => {
    const { t } = useTranslation();

    const defaultValues: CustomPaymentMethodFormValues = {
        name: '',
        isActive: true
    };

    const handleSubmit = async (values: CustomPaymentMethodFormValues) => {
        const finalValues = sanitizeFormValues(values);
        return onSubmit(finalValues);
    };

    return (
        <Formik
            initialValues={{ ...defaultValues, ...initialValues }}
            validationSchema={customPaymentMethodValidationSchema}
            onSubmit={handleSubmit}
        >
            {formikProps => (
                <FormWrapper submitText={submitText} isSubmitting={formikProps.isSubmitting}>
                    <Grid container alignItems='center' spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <InputField<CustomPaymentMethodFormValues> name="name" label={t('Name')} formikProps={formikProps} required />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <SwitchField name="isActive" label={t('Active')} formikProps={formikProps} />
                        </Grid>
                    </Grid>
                </FormWrapper>
            )}
        </Formik>
    );
};

export default CustomPaymentMethodForm;
